module.exports = __webpack_public_path__ + "img/banner_main2.5a8f67d1.jpg";